import { useState } from "react";

const faqs = [
  {
    q: "什么是恋爱后宫题材漫画？",
    a: "恋爱后宫题材漫画以主角的感情线为核心，通常围绕暧昧、同居、校园等生活场景展开，塑造多位性格各异的角色。后宫番偏向多角色群像，恋爱番更聚焦一段真挚的感情，两者都充满青春气息与心动细节。",
  },
  {
    q: "这里的内容多久更新一次？",
    a: "我们会跟进热门恋爱后宫题材漫画的连载进度，保持每日更新热门作品的章节，同时每周整理题材专题与入坑指南。你可以在首页「最新更新」板块和分类专区看到最新动态。",
  },
  {
    q: "如何找到自己喜欢的题材？",
    a: "可以通过顶部导航进入「分类专区」，按恋爱、后宫、暧昧、同居、校园、逆后宫等题材筛选，也可以使用搜索框直接输入作品名或关键词查找，分类清晰，查找方便。",
  },
  {
    q: "作品分类是怎么划分的？",
    a: "我们根据故事主线的核心氛围划分题材：校园侧重青春日常，同居侧重生活情感，暧昧侧重若即若离的心动，后宫与逆后宫则侧重多角色群像。一部作品可能同时归属多个相关分类。",
  },
  {
    q: "逆后宫和普通后宫有什么区别？",
    a: "普通后宫作品通常以男性主角为中心，围绕多位女性角色展开；逆后宫则相反，以女性主角为中心，围绕多位男性角色展开。两类都主打甜蜜的心动体验，只是视角不同。",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="max-w-4xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="text-center mb-10">
        <p className="text-sm font-medium text-primary-600 tracking-widest">FAQ</p>
        <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          常见问题
        </h2>
        <p className="mt-3 text-sm text-foreground-600">
          关于恋爱后宫题材漫画的分类、更新与使用，这里都有答案。
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {faqs.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div
              key={item.q}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900">
                  {item.q}
                </h3>
                <span className={`w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                  <i className="ri-add-line"></i>
                </span>
              </button>
              {isOpen && (
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}